// node_modules
import { FC, useEffect, useState } from "react";
// Controllers
import { CaseControllerSingleton } from "Controllers";
// Enums
import { ToastTypeEnum } from "Enums";
// Helpers
import { ToastHelperSingleton } from "Helpers";
// styles
import styles from "./caseScope.module.scss";

type TCaseScopeProps = {
    caseId: number,
    caseScope: number,
    isEditMode: boolean
}

export const CaseScope: FC<TCaseScopeProps> = ({caseId, caseScope, isEditMode}: TCaseScopeProps) => {
    // State
    const [scope, setScope] = useState<number>(0);

    // Logic
    useEffect(() => {
        if (caseScope < 0 || caseScope > 4) { setScope(0); }
        setScope(caseScope);
    }, [caseScope]);

    const getScopeTextValue = (scopeNumberValue: number): string => {
        switch (scopeNumberValue) {
            case 1: return "Discover";
            case 2: return "Demonstrate";
            case 3: return "Develop";
            case 4: return "Deploy";
            default: return "None";
        }
    };

    const getPolyClassname = (number: number): string => {
        const classNameList = [styles.scopePoly];
        if(number === scope) {classNameList.push(styles.active);}       
        return classNameList.join(" ");
    };

    const getTextScope = (number: number): string => {
        const classNameList = [styles.scopeText];
        if(number === scope) {classNameList.push(styles.active);}       
        return classNameList.join(" ");
    };

    const updateCaseScopeAsync = async (clickedScope: number): Promise<void> => {
        if (!isEditMode) { return; }
        
        let newCaseScope: number = clickedScope;
        // user clicked on current scope
        if (clickedScope === scope) { newCaseScope = 0; }

        // set component state
        setScope(newCaseScope);

        // call server to update case scope
        const isSuccess: boolean = await CaseControllerSingleton
            .updateCaseScopeAsync(caseId, newCaseScope);

        // tell user about update result 
        if (!isSuccess) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, `Was not able to update case scope to ${getScopeTextValue(newCaseScope)}.`);
        } else {
            ToastHelperSingleton.showToast(ToastTypeEnum.Success, `Successfully updated case scope to ${getScopeTextValue(newCaseScope)}.`);
        }
        
        return;
    };

    if (scope === 0 && !isEditMode) {
        return (<></>);
    } else {
        return (
            <div className={styles.intakeItem}>
                <h4>Scope</h4>
                <svg id="scope-selection" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 392 160">
                    <polygon 
                        className={getPolyClassname(1)} 
                        points="1,1 90,24 90,96 1,120"
                        onClick={() => updateCaseScopeAsync(1)}></polygon>
                    <polygon 
                        className={getPolyClassname(2)} 
                        points="100,26 190,50 190,70 100,94"
                        onClick={() => updateCaseScopeAsync(2)}></polygon>
                    <polygon 
                        className={getPolyClassname(3)} 
                        points="200,50 290,26 290,94 200,70"
                        onClick={() => updateCaseScopeAsync(3)}></polygon>
                    <polygon 
                        className={getPolyClassname(4)} 
                        points="300,24 390,1 390,120 300,96"
                        onClick={() => updateCaseScopeAsync(4)}></polygon>
                    <text className={getTextScope(1)} x="17" y="145">{getScopeTextValue(1)}</text>
                    <text className={getTextScope(2)} x="100" y="145">{getScopeTextValue(2)}</text>
                    <text className={getTextScope(3)} x="215" y="145">{getScopeTextValue(3)}</text>
                    <text className={getTextScope(4)} x="311" y="145">{getScopeTextValue(4)}</text>
                </svg>
            </div>
        );
    }
};